import HomeIcon from "@mui/icons-material/Home";

export const STEPS_OPTIONS_TIME_TRACKER = [
  {
    label: "Home",
    value: "home",
    icon: <HomeIcon />,
    route: "/dashboards/user-dashboard/",
  },
  {
    label: "Track Time",
    value: "track-time",
  },
];
